export const formatedCurrency = (value: number) => {
    const formatoPesos = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
    });

    return formatoPesos.format(value);
};
